import React from 'react'

import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Text } from '@fairhq/common'

import { Layout } from 'layout/Layout'

import { SurveyWindowPrompt } from './SurveyWindowPrompt'
import { SurveyWindowsArchive } from './SurveyWindowsArchive'

const Container = styled.div`
  display: flex;
  gap: 40px;
  flex-direction: column;
`
const Header = styled.header`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Surveys = () => {
  const { t } = useTranslation()

  return (
    <Layout dark>
      <Container>
        <Header>
          <Text element="h1" type="heading" size="xl" fontWeight={700}>
            {t('surveys.title')}
          </Text>
          <Text element="p" type="body" size="sm" fontWeight={500}>
            {t('surveys.description')}
          </Text>
        </Header>
        <SurveyWindowPrompt />
        <SurveyWindowsArchive />
      </Container>
    </Layout>
  )
}
